export function constructTitleWithGrammer(numberOfChannels: number): string {
  if (numberOfChannels === 1) return `Great! You've connected a Channel`

  return `Great! You've connected ${numberOfChannels} Channels`
}
